import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_ORDER_PROVIDER_DETAILS/REQUESTED';
const BLOCKED = '$FETCH_ORDER_PROVIDER_DETAILS/BLOCKED';
const APPROVED = '$FETCH_ORDER_PROVIDER_DETAILS/APPROVED';
const SUCCEEDED = '$FETCH_ORDER_PROVIDER_DETAILS/SUCCEEDED';
const FAILED = '$FETCH_ORDER_PROVIDER_DETAILS/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      bufferMode?: boolean;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
